import { PHONE_NUMBER_REGEXP } from "common/regExp";
import * as Yup from "yup";

declare module "yup" {
  export interface StringSchema {
    emailNameLength(length: number, message: string): StringSchema;
  }
}

Yup.addMethod(
  Yup.string,
  "emailNameLength",
  function (length: number, errorMessage: string) {
    return this.test(`test-email-name-length`, errorMessage, function (value) {
      const { path, createError } = this;

      if (!value) return createError({ path, message: errorMessage });

      const emailName = value.split("@")[0];

      return (
        emailName.length <= length ||
        createError({ path, message: errorMessage })
      );
    });
  }
);

const MAX_FIRST_NAME_LENGTH = 32;
const MAX_LAST_NAME_LENGTH = 32;
const MAX_EMAIL_LENGTH = 64;
const MAX_LICENSE_NUMBER_LENGTH = 20;

export const editUserValidationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .required("First Name is required field")
    .max(
      MAX_FIRST_NAME_LENGTH,
      `First Name is too long. Maximum ${MAX_FIRST_NAME_LENGTH}} character`
    ),
  lastName: Yup.string()
    .trim()
    .required("Last Name is required field")
    .max(
      MAX_LAST_NAME_LENGTH,
      `Last Name is too long. Maximum ${MAX_LAST_NAME_LENGTH}} character`
    ),
  email: Yup.string()
    .trim()
    .required("Email is required field")
    .email("Email is invalid")
    .emailNameLength(
      MAX_EMAIL_LENGTH,
      `Email is too long. Maximum ${MAX_EMAIL_LENGTH} character`
    ),
  licenseNumber: Yup.string()
    .trim()
    .required("License Number is required field")
    .max(
      MAX_LICENSE_NUMBER_LENGTH,
      `License Number is too long. Maximum ${MAX_LICENSE_NUMBER_LENGTH}} character`
    ),
  phoneNumber: Yup.string()
    .trim()
    .required("Phone Number is required field")
    .matches(PHONE_NUMBER_REGEXP, "Phone number is invalid")
});
